export default "__VITE_ASSET__CCFTuOoo__"